/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-permission-editor[_ngcontent-%COMP%]{padding:10px}app-permission-editor[_ngcontent-%COMP%]   mat-checkbox.mat-checkbox-checked[_ngcontent-%COMP%]   div.mat-checkbox-background[_ngcontent-%COMP%]{background-color:green!important}app-permission-editor[_ngcontent-%COMP%]   div.row[_ngcontent-%COMP%]{margin-top:10px}.grup[_ngcontent-%COMP%]{position:absolute;margin-top:10px!important;margin-left:10px}"];
export { styles as styles };
